<template>
	<div class="">
		<!-- title -->
		<div>
			<h1 class="text-center text-base font-medium sm:text-lg pb-4">
				Setup your user profile
			</h1>
		</div>
		<form class="space-y-4" @submit.prevent>
			<ErrorNotification :errorMessage="formErrorMessage"/>
			<!-- email input -->
			<CustomInput
				id="emailInput"
				v-model="createProfileRequest.firstName"
				placeholder="First name"
				name="firstName"
				type="text"
			/>
			<CustomInput
				id="emailInput"
				v-model="createProfileRequest.lastName"
				placeholder="Last name"
				name="lastName"
				type="text"
			/>

			<!-- password input -->
			<CustomInput
				id="passwordInput"
				v-model="createProfileRequest.password"
				placeholder="Password"
				name="password"
				type="password"
			/>
			<CustomInput
				id="passwordInput"
				v-model="confirmPassword"
				placeholder="Confirm Password"
				name="password"
				type="password"
				:error="errors.password"
			/>


			<!-- sign in button -->
			<CustomButton
				id="signInButton"
				text="Create Account"
				:disabled="!secure || !matching"
				@click="signUp()"
				:loading="loading"
				color="blue-600"
				class="py-4 text-base"
			/>

			<div class="text-gray-700 text-sm">
				<h2 class="font-medium">Password requirements</h2>
				<p >Please follow this guide for a strong password</p>
				<p :class="emailStrong.special ? 'text-blue-600 font-medium':'text-gray-700'">- One special character</p>
				<p :class="emailStrong.length ? 'text-blue-600 font-medium':'text-gray-700'">- Min 8 characters</p>
				<p :class="emailStrong.number ? 'text-blue-600 font-medium':'text-gray-700'">- One number (2 recommended)</p>
				<p :class="emailStrong.capital ? 'text-blue-600 font-medium':'text-gray-700'">- One capital</p>
				<p :class="matching ? 'text-blue-600 font-medium':'text-gray-700'">- Matching</p>
				
			</div>
			
		</form>
	</div>
</template>

<script>
import CustomInput from "@/components/inputs/CustomInput.vue";
import CustomButton from "@/components/inputs/CustomButton.vue";
import ErrorNotification from '@/components/inputs/ErrorNotification.vue'


export default {
	name: "SignIn",
	components: {
		CustomInput,
		CustomButton,
		ErrorNotification
	},
	props:{
		backdoorKey:{
			type:String
		}},
	data() {
		return {
			createProfileRequest:{
				inviteId:this.$route.params.id,
				firstName:"",
				lastName:"",
				password:"",
			},
			confirmPassword:"",

			emailStrong:{
			special:false,
			length:false,
			number:false,
			capital:false,
			},

			loading: false,
			formErrorMessage: "",
			showErrorModal: false,
			errors: {
				type: Object,
				default: function() {
					return {
						email: "",
						password: ""
					}
				}
			}
		}
	},
	created(){
		
	},
	methods: {
		closeModal() {
			this.showErrorModal = false;
		},

		async signUp(){
			try {
				const response = await fetch(`https://${process.env.VUE_APP_DEFAULT_API}.boogi.io/private/api/client/auth/accept-invite`, {
					method: "POST",
					body:JSON.stringify(this.createProfileRequest),
					headers: {
						"Content-Type": "application/json",
					},
				});

				if (response.ok) {
					var object = await response.json()
					var token = "Bearer "+object.token
					localStorage.setItem('token', token)

					this.getUser()
                    
				}
				else
				{
					this.formErrorMessage = "Invitation has timed out"
				}
				
			} catch (error) {
				this.formErrorMessage = "Invitation has timed out"
				return;
			}


		},

		async getUser(){
			try {
				const token = localStorage.getItem('token')
                this.loading = true

				const response = await fetch(`https://${process.env.VUE_APP_DEFAULT_API}.boogi.io/private/api/client/user`, {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						"Authorization": `${token}`,
					},
				});

				if (response.ok) {
					var object = await response.json()
					var publisher = object.publisher
					localStorage.setItem("firstName",object.publisherUser.firstName)
					localStorage.setItem("lastName", object.publisherUser.lastName)
					localStorage.setItem("publisher",publisher.companyName)
					localStorage.setItem("publisherStatus",publisher.publisherStatus)
					localStorage.setItem("sandbox",publisher.sandboxOnly)

					if(publisher.sandboxOnly)
					{
						localStorage.setItem("apiType",process.env.VUE_APP_SANDBOX_API)

					}else
					{
						localStorage.setItem("apiType",process.env.VUE_APP_DEFAULT_API)

					}
					
					this.$router.push("/")

				}else
				{
					this.formErrorMessage = "Invitation has timed out"
				}
				
			} catch (error) {
				this.formErrorMessage = "Invitation has timed out"
				return;
			}

		},

	},
	computed: {
		matching()
		{
			return (this.confirmPassword === this.createProfileRequest.password && this.createProfileRequest.password != ''&& this.createProfileRequest.firstName != '' && this.createProfileRequest.lastName != '')
		},
		secure()
		{
			return (this.emailStrong.length && this.emailStrong.special && this.emailStrong.number && this.emailStrong.capital)
		}
	},
	mounted() {
        document.title = "New user";
    },
	watch: {
		createProfileRequest:{
		deep: true,
		handler: function(val){
				
						if (val.password.match(/^(?=.*[A-Z])/)) {
							this.emailStrong.capital = true}
						else
						{
						this.emailStrong.capital = false;
						}
						if (val.password.match(/^(?=.*[0-9])/)) { 
							this.emailStrong.number = true}
						else
						{
						this.emailStrong.number = false;
						}
						if (val.password.match(/^(?=.*[!@#$%^&*-])/)){ 
							this.emailStrong.special = true}
						else
						{
						this.emailStrong.special = false;
						}
						if (val.password.match(/^(?=.{8,})/)) {
							this.emailStrong.length = true}
						else
						{
						this.emailStrong.length = false;
						}
		}
	}
	}
}
</script>

<style >
</style>

